define('Components/Comein/js/models/CagnotteModel',['underscore','backbone','UrlFactory','app','formatPrice','moment'],function(_,Backbone,UrlFactory,app,formatPrice,moment){

    var DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss ZZ';

    //
    // Model Cagnotte Come in ®
    //
    return Backbone.Model.extend({

        defaults:{
            expirationDate:''
        },

       initialize:function(){

            var model = this;
           var customer = app.getCustomer(),
               points = customer.get('customer_loyalty') || 0;

           var enable_discount =   app.getCustomer().getDiscount().filter(function (e) {

               if (!app.getCart().getVoucher().findWhere({name:e.name}))
               {

                   return e;
               }

           } );

           var options = {
                   idNeolane:customer.getNeolaneParam('account',''),
                   quantity: points,
                   amount: points,
                   discounts:enable_discount,
                   expirationDate:moment(customer.getNeolaneParam('amountExpirationDate'),DATE_FORMAT).toDate(),
                   // TODO valeur statique, utiliser une configuration
                   percent:5 // pourcentage de réduction pour les adhérents Come In
           }, history = [];
           var mouvements = customer.get('mouvements');
            _(mouvements).each(function(m) {
                var  v= m.amount,
                origin = m.origine,
                addMoment = moment(m.date_add,DATE_FORMAT),
                type = m.type,
                store_name=m.store_name,
                label = origin || store_name || '';
                history.push({
                    amount:v,
                    amountFormated: model.formatAmountSign(v, type),
                    date_add:addMoment.toDate(),
                    moment:addMoment,
                    label:label,
                    type:type,
                    solde:m.solde
                });

             });
           history.reverse();
           options.history = history;
           model.set(options);
       },
        getStatusActive:function (id) {
           return app.getCustomer().getSegment();
        },
        getAmount: function () {
            var points = app.getCustomer().get('customer_loyalty_cagnotte');
            return points;
        },
        formatAmount: function () {
            return formatPrice(this.getAmount());
        },
        isExpire: function () {
            return false;
        },
        formatExpirationDate: function () {
            var expirationDate = moment(moment(app.getCustomer().getNeolaneParam('amountExpirationDate'), DATE_FORMAT).toDate())
            return expirationDate.format('LL');
        },
        formatAmountSign:function(v, type){
          var sign = (type == "B" || type == "P"   ?  '-' : '+');
            return sign +  '   ' + formatPrice(v);
        },
        formatAmount:function(format){
            return formatPrice(this.getAmount(),format);
        },
        getAmount:function(){
            return this.get('amount');
        },
        isExpire:function(){
            var date = this.getExpirationMoment();
            return (!date.isValid()) || date.fromNow()>0;
        },
        getExpirationDate:function(){
            return this.get('expirationDate');
        },
        getExpirationMoment:function(){
            return moment(this.getExpirationDate())
        },
        formatExpirationDate:function(format){
            return this.getExpirationMoment().format(format);
        },
        getTransactionHistory:function(){
            return _(this.get('history'));
        },
        getDiscounts:function(){
            return _(this.get('discounts'));
        },
    });
})
;
